import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrum from '../../components/common/Breadcrum';
import ServerTable from '../../components/table/ServerTable';
import Select from '../../components/form/Select';
import Models from '../../components/common/Models';
import moment from 'moment';
import axiosInstance from '../../services/axios';
import { toast } from 'react-toastify';

export default function AdminTask() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [priorityFilter, setPriorityFilter] = useState('ALL');
  const [tableRow, setTableRow] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [todoList, setTodoList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'MEDIUM',
    dueDate: '',
    assignedTo: '',
    status: 'PENDING'
  });
  const [loading, setLoading] = useState(false);
  const [todoStats, setTodoStats] = useState(null);
  const [totalTodos, setTotalTodos] = useState(0);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewTaskData, setViewTaskData] = useState(null);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [taskComments, setTaskComments] = useState([]);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedTaskForStatus, setSelectedTaskForStatus] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedTaskForDelete, setSelectedTaskForDelete] = useState(null);

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/admin/dashboard' },
    { label: 'Task Management', path: '/admin/tasks' }
  ];

  const statusOptions = [
    { value: "ALL", label: "All Status" },
    { value: "PENDING", label: "Pending" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "COMPLETED", label: "Completed" },
    { value: "OVERDUE", label: "Overdue" }
  ];

  const priorityOptions = [
    { value: "ALL", label: "All Priority" },
    { value: "LOW", label: "Low" },
    { value: "MEDIUM", label: "Medium" },
    { value: "HIGH", label: "High" },
    { value: "URGENT", label: "Urgent" }
  ];

  const employeeOptions = [
    { value: "1", label: "John Doe" },
    { value: "2", label: "Jane Smith" },
    { value: "3", label: "Mike Johnson" }
  ];

  const tableColumns = [
    { id: 'serialNo', label: 'S.No', type: 'text' },
    { id: 'title', label: 'Task Title', type: 'text' },
    { id: 'description', label: 'Description', type: 'text' },
    { id: 'assignedTo', label: 'Assigned To', type: 'text' },
    { id: 'priority', label: 'Priority', type: 'badge' },
    { id: 'status', label: 'Status', type: 'badge' },
    { id: 'dueDate', label: 'Due Date', type: 'date' },
    { id: 'createdAt', label: 'Created', type: 'date' },
    {
      id: "action",
      label: "Action",
      type: "action",
      actions: [
        { id: "view", name: "View", className: "w-18 h-8 px-2 bg-blue-500 hover:bg-blue-600 text-white rounded-full flex items-center justify-center text-xs transition-colors" },
        { id: "edit", name: "Edit", className: "w-18 h-8 px-2 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center text-xs transition-colors" },
        { id: "changeStatus", name: "Status", className: "w-18 h-8 px-2 bg-orange-500 hover:bg-orange-600 text-white rounded-full flex items-center justify-center text-xs transition-colors" },
        { id: "comment", name: "Comment", className: "w-18 h-8 px-2 bg-purple-500 hover:bg-purple-600 text-white rounded-full flex items-center justify-center text-xs transition-colors" },
        { id: "delete", name: "Delete", className: "w-18 h-8 px-2 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center text-xs transition-colors" }
      ]
    }
  ];

  // Mock data - replace with actual Redux state
  const mockTasks = [];

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  const getEmployeeList = async () => {
    try {
      const response = await axiosInstance.get('/admin/employee/list');
      setEmployeeList(response.data.data);
    } catch (error) {
      toast.error('Failed to fetch employee list');
    }
  };

  const getTodoList = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: rowsPerPage,
        search: searchTerm || undefined,
        status: statusFilter === 'ALL' ? undefined : statusFilter,
        priority: priorityFilter === 'ALL' ? undefined : priorityFilter
      };

      const response = await axiosInstance.get('/todos', { params });
      setTodoList(response.data.data);
      setTotalTodos(response.data.total || 0);
    } catch (error) {
      toast.error('Failed to fetch todo list');
      setTodoList([]);
    } finally {
      setLoading(false);
    }
  };

  const getTodoStats = async () => {
    try {
      const response = await axiosInstance.get('/todos/stats');
      setTodoStats(response.data.data);
    } catch (error) {
      console.error('Failed to fetch todo stats');
    }
  };

  const getTaskById = async (taskId) => {
    try {
      const response = await axiosInstance.get(`/todos/${taskId}`);
      return response.data.data;
    } catch (error) {
      toast.error('Failed to fetch task details');
      return null;
    }
  };

  const addTaskComment = async (taskId, commentText) => {
    try {
      setLoading(true);
      await axiosInstance.post(`/todos/${taskId}/comments`, { comment: commentText });
      toast.success('Comment added successfully');
      setComment('');
      setIsCommentModalOpen(false);
    } catch (error) {
      console.error('Comment error:', error);
      toast.error('Failed to add comment');
    } finally {
      setLoading(false);
    }
  };

  const handleTableAction = async (action, row) => {
    console.log('Action clicked:', action, 'Row data:', row);
    
    if (action === 'View') {
      setLoading(true);
      const taskDetails = await getTaskById(row.uuid);
      setLoading(false);
      if (taskDetails) {
        setViewTaskData(taskDetails);
        setIsViewModalOpen(true);
      }
    } else if (action === 'Edit') {
      setSelectedTask(row);
      setFormData({
        title: row.originalTitle || '',
        description: row.originalDescription || '',
        priority: row.originalPriority || 'MEDIUM',
        dueDate: row.originalDueDate || '',
        assignedTo: row.assignedToId || '',
        status: row.originalStatus || 'PENDING'
      });
      setIsModalOpen(true);
    } else if (action === 'Status') {
      setSelectedTaskForStatus(row);
      setIsStatusModalOpen(true);
    } else if (action === 'Delete') {
      setSelectedTaskForDelete(row);
      setIsDeleteModalOpen(true);
    } else if (action === 'Comment') {
      setSelectedTask(row);
      setIsCommentModalOpen(true);
    }
  };

  const handleDeleteConfirm = async () => {
    if (selectedTaskForDelete) {
      try {
        setLoading(true);
        await axiosInstance.delete(`/todos/${selectedTaskForDelete.uuid}`);
        toast.success('Task deleted successfully');
        await Promise.all([getTodoList(), getTodoStats()]);
        setIsDeleteModalOpen(false);
        setSelectedTaskForDelete(null);
      } catch (error) {
        console.error('Delete error:', error);
        toast.error('Failed to delete task');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleStatusUpdate = async (newStatus) => {
    if (selectedTaskForStatus) {
      try {
        setLoading(true);
        await axiosInstance.put(`/todos/${selectedTaskForStatus.uuid}`, { status: newStatus });
        toast.success(`Task marked as ${newStatus.toLowerCase().replace('_', ' ')}`);
        await Promise.all([getTodoList(), getTodoStats()]);
        setIsStatusModalOpen(false);
        setSelectedTaskForStatus(null);
      } catch (error) {
        toast.error('Failed to update task status');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    if (comment.trim() && selectedTask) {
      addTaskComment(selectedTask.uuid, comment);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (selectedTask) {
        // Update task
        await axiosInstance.put(`/todos/${selectedTask.uuid}`, formData);
        toast.success('Task updated successfully');
      } else {
        // Create new task
        await axiosInstance.post('/todos', formData);
        toast.success('Task created successfully');
      }
      
      // Refresh both todo list and stats after successful operation
      await Promise.all([getTodoList(), getTodoStats()]);
      resetForm();
    } catch (error) {
      toast.error(selectedTask ? 'Failed to update task' : 'Failed to create task');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      priority: 'MEDIUM',
      dueDate: '',
      assignedTo: '',
      status: 'PENDING'
    });
    setSelectedTask(null);
    setIsModalOpen(false);
  };
  
  const getPriorityBadgeClass = (priority) => {
    switch (priority) {
      case 'URGENT': return 'bg-red-600 text-white';
      case 'HIGH': return 'bg-red-400 text-white';
      case 'MEDIUM': return 'bg-yellow-400 text-black';
      case 'LOW': return 'bg-green-400 text-white';
      default: return 'bg-gray-400 text-white';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'COMPLETED': return 'bg-green-500 text-white';
      case 'IN_PROGRESS': return 'bg-blue-500 text-white';
      case 'PENDING': return 'bg-yellow-500 text-black';
      case 'OVERDUE': return 'bg-red-500 text-white';
      default: return 'bg-gray-500 text-white';
    }
  };
  useEffect(()=>{
    getEmployeeList()
    getTodoStats()
  },[])

  useEffect(() => {
    getTodoList();
  }, [currentPage, rowsPerPage, searchTerm, statusFilter, priorityFilter]);

  useEffect(() => {
    if (todoList.todos && Array.isArray(todoList.todos)) {
      const updatedRows = todoList.todos?.map((task, index) => ({
        uuid: task.id,
        serialNo: (currentPage - 1) * rowsPerPage + index + 1,
        title: task.title && task.title.length > 30 ? `${task.title.substring(0, 30)}...` : (task.title || 'No Title'),
        description: task.description ? (task.description.length > 40 ? `${task.description.substring(0, 40)}...` : task.description) : 'No description',
        assignedTo: task.employee?.name || 'Unassigned',
        assignedToId: task.assignedTo,
        priority: <span className={`px-2 py-1 rounded text-xs ${getPriorityBadgeClass(task.priority)}`}>{task.priority}</span>,
        status: <span className={`px-2 py-1 rounded text-xs ${getStatusBadgeClass(task.status)}`}>{task.status}</span>,
        dueDate: task.dueDate ? moment(task.dueDate).format('YYYY-MM-DD') : 'No due date',
        createdAt: moment(task.createdAt).format('YYYY-MM-DD'),
        // Store original values for editing - make sure these exist
        originalTitle: task.title || '',
        originalDescription: task.description || '',
        originalPriority: task.priority || 'MEDIUM',
        originalStatus: task.status || 'PENDING',
        originalDueDate: task.dueDate ? moment(task.dueDate).format('YYYY-MM-DD') : ''
      }));
      setTableRow(updatedRows);
    } else {
      setTableRow([]);
    }
  }, [todoList, currentPage, rowsPerPage]);

  return (
    <>
      {/* Stats Cards */}
      {todoStats && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          <div className="bg-blue-500 text-white p-4 rounded-lg">
            <h3 className="text-lg font-semibold">Total Tasks</h3>
            <p className="text-2xl">{todoStats.total || 0}</p>
          </div>
          <div className="bg-yellow-500 text-white p-4 rounded-lg">
            <h3 className="text-lg font-semibold">Pending</h3>
            <p className="text-2xl">{todoStats.pending || 0}</p>
          </div>
          <div className="bg-green-500 text-white p-4 rounded-lg">
            <h3 className="text-lg font-semibold">Completed</h3>
            <p className="text-2xl">{todoStats.completed || 0}</p>
          </div>
          <div className="bg-red-500 text-white p-4 rounded-lg">
            <h3 className="text-lg font-semibold">Overdue</h3>
            <p className="text-2xl">{todoStats.overdue || 0}</p>
          </div>
        </div>
      )}

      <div className='bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center'>
        <div>
          <h1 className='text-2xl font-semibold text-theme-dark dark:text-theme-light'>Task Management</h1>
          <Breadcrum items={breadcrumbItems} />
        </div>
        <div className='flex justify-end items-center gap-3'>
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={(selected) => setStatusFilter(selected)}
            placeholder="Filter by Status"
          />
          <Select
            options={priorityOptions}
            value={priorityFilter}
            onChange={(selected) => setPriorityFilter(selected)}
            placeholder="Filter by Priority"
          />
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg whitespace-nowrap"
          >
            Add New Task
          </button>
        </div>
      </div>

      <div className='mt-4'>
        <ServerTable
          tableColumns={tableColumns}
          title="Tasks"
          data={tableRow}
          total={totalTodos}
          loading={loading}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
          searchTerm={searchTerm}
          onSearch={handleSearch}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          handleTableAction={handleTableAction}
        />
      </div>

      {/* Task Modal */}
      <Models isOpen={isModalOpen} isClose={resetForm}>
        <div className="p-6 max-w-2xl w-full">
          <h2 className="text-xl font-bold mb-4">
            {selectedTask ? 'Edit Task' : 'Add New Task'}
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Task Title *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({...formData, title: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter task title"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Description</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg h-24 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter task description"
                  required
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">Priority *</label>
                  <select
                    value={formData.priority}
                    onChange={(e) => setFormData({...formData, priority: e.target.value})}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="LOW">Low</option>
                    <option value="MEDIUM">Medium</option>
                    <option value="HIGH">High</option>
                    <option value="URGENT">Urgent</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">Status</label>
                  <select
                    value={formData.status}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="PENDING">Pending</option>
                    <option value="IN_PROGRESS">In Progress</option>
                    <option value="COMPLETED">Completed</option>
                    <option value="CANCELLED">Cancelled</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">Assign To *</label>
                  <select
                    value={formData.assignedTo}
                    onChange={(e) => setFormData({...formData, assignedTo: e.target.value})}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  >
                    <option value="">Select Employee</option>
                    {employeeList.length > 0 && employeeList.map(emp => (
                      <option key={emp.id} value={emp.id}>{emp.name} ({emp.email})</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">Due Date</label>
                  <input
                    type="date"
                    value={formData.dueDate}
                    onChange={(e) => setFormData({...formData, dueDate: e.target.value})}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    min={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Saving...' : (selectedTask ? 'Update Task' : 'Create Task')}
              </button>
            </div>
          </form>
        </div>
      </Models>

      {/* View Task Modal */}
      <Models isOpen={isViewModalOpen} isClose={() => setIsViewModalOpen(false)}>
        {viewTaskData && (
          <div className="p-6 max-w-3xl w-full">
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Task Details</h2>
              <button
                onClick={() => setIsViewModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-6">
              {/* Task Information */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-gray-700">Task Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Title</label>
                    <p className="mt-1 text-gray-900 font-medium">{viewTaskData.title}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Status</label>
                    <span className={`inline-block mt-1 px-3 py-1 rounded-full text-sm ${getStatusBadgeClass(viewTaskData.status)}`}>
                      {viewTaskData.status}
                    </span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Priority</label>
                    <span className={`inline-block mt-1 px-3 py-1 rounded-full text-sm ${getPriorityBadgeClass(viewTaskData.priority)}`}>
                      {viewTaskData.priority}
                    </span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Due Date</label>
                    <p className="mt-1 text-gray-900">{viewTaskData.dueDate ? moment(viewTaskData.dueDate).format('YYYY-MM-DD') : 'No due date'}</p>
                  </div>
                </div>
                
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-600">Description</label>
                  <p className="mt-1 text-gray-900 whitespace-pre-wrap">{viewTaskData.description || 'No description provided'}</p>
                </div>
              </div>

              {/* Assignment Information */}
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-gray-700">Assignment Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Assigned To</label>
                    <p className="mt-1 text-gray-900">{viewTaskData.employee?.name || 'Unassigned'}</p>
                    {viewTaskData.employee?.email && (
                      <p className="text-sm text-gray-600">{viewTaskData.employee.email}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Assigned By</label>
                    <p className="mt-1 text-gray-900">{viewTaskData.assignerDetails?.name || 'System'}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Created At</label>
                    <p className="mt-1 text-gray-900">{moment(viewTaskData.createdAt).format('YYYY-MM-DD HH:mm:ss')}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Updated At</label>
                    <p className="mt-1 text-gray-900">{moment(viewTaskData.updatedAt).format('YYYY-MM-DD HH:mm:ss')}</p>
                  </div>
                </div>
              </div>

              {/* Tags and Attachments */}
              {(viewTaskData.tags?.length > 0 || viewTaskData.attachments?.length > 0) && (
                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-gray-700">Additional Information</h3>
                  {viewTaskData.tags?.length > 0 && (
                    <div className="mb-3">
                      <label className="block text-sm font-medium text-gray-600 mb-2">Tags</label>
                      <div className="flex flex-wrap gap-2">
                        {viewTaskData.tags.map((tag, index) => (
                          <span key={index} className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  {viewTaskData.attachments?.length > 0 && (
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">Attachments</label>
                      <div className="space-y-1">
                        {viewTaskData.attachments.map((attachment, index) => (
                          <a key={index} href={attachment} target="_blank" rel="noopener noreferrer" 
                             className="block text-blue-600 hover:text-blue-800 text-sm underline">
                            Attachment {index + 1}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Comments Section */}
              {viewTaskData.comments?.length > 0 && (
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-gray-700">Comments</h3>
                  <div className="space-y-3 max-h-60 overflow-y-auto">
                    {viewTaskData.comments.map((comment, index) => (
                      <div key={index} className="bg-white p-3 rounded border-l-4 border-yellow-400">
                        <p className="text-gray-900">{comment.comment}</p>
                        <div className="flex justify-between items-center mt-2 text-xs text-gray-500">
                          <span>By: {comment.user?.name || 'Unknown'}</span>
                          <span>{moment(comment.createdAt).format('YYYY-MM-DD HH:mm')}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-between mt-6">
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setIsViewModalOpen(false);
                    setSelectedTask({ uuid: viewTaskData.id, originalTitle: viewTaskData.title, originalDescription: viewTaskData.description, originalPriority: viewTaskData.priority, originalStatus: viewTaskData.status, originalDueDate: viewTaskData.dueDate ? moment(viewTaskData.dueDate).format('YYYY-MM-DD') : '', assignedToId: viewTaskData.assignedTo });
                    setFormData({
                      title: viewTaskData.title,
                      description: viewTaskData.description,
                      priority: viewTaskData.priority,
                      dueDate: viewTaskData.dueDate ? moment(viewTaskData.dueDate).format('YYYY-MM-DD') : '',
                      assignedTo: viewTaskData.assignedTo,
                      status: viewTaskData.status
                    });
                    setIsModalOpen(true);
                  }}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  Edit Task
                </button>
                <button
                  onClick={() => {
                    setIsViewModalOpen(false);
                    setSelectedTask({ uuid: viewTaskData.id });
                    setIsCommentModalOpen(true);
                  }}
                  className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600"
                >
                  Add Comment
                </button>
              </div>
              <button
                onClick={() => setIsViewModalOpen(false)}
                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Models>

      {/* Add Comment Modal */}
      <Models isOpen={isCommentModalOpen} isClose={() => setIsCommentModalOpen(false)}>
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Add Comment</h2>
          <form onSubmit={handleCommentSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1 text-gray-700">Comment</label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg h-32 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter your comment..."
                required
              />
            </div>
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => {
                  setComment('');
                  setIsCommentModalOpen(false);
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600"
                disabled={loading}
              >
                {loading ? 'Adding...' : 'Add Comment'}
              </button>
            </div>
          </form>
        </div>
      </Models>

      {/* Status Change Modal */}
      <Models isOpen={isStatusModalOpen} isClose={() => setIsStatusModalOpen(false)}>
        <div className="p-6 w-full bg-white dark:bg-gray-800">
          <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-gray-100">Change Task Status</h2>
          
          {selectedTaskForStatus && (
            <div className="mb-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">Task: {selectedTaskForStatus.originalTitle}</p>
              <p className="text-xs text-gray-500 dark:text-gray-500">
                Current Status: 
                <span className={`ml-2 px-2 py-1 rounded text-xs ${getStatusBadgeClass(selectedTaskForStatus.originalStatus)}`}>
                  {selectedTaskForStatus.originalStatus}
                </span>
              </p>
            </div>
          )}

          <div className="space-y-3">
            <button
              onClick={() => handleStatusUpdate('PENDING')}
              disabled={selectedTaskForStatus?.originalStatus === 'PENDING'}
              className={`w-full text-left px-4 py-3 rounded-lg border transition-colors duration-200 flex items-center gap-3 ${
                selectedTaskForStatus?.originalStatus === 'PENDING'
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed border-gray-200 dark:border-gray-600'
                  : 'bg-yellow-50 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-300 border-yellow-200 dark:border-yellow-700 hover:bg-yellow-100 dark:hover:bg-yellow-900/40'
              }`}
            >
              <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
              <div>
                <p className="font-medium">Pending</p>
                <p className="text-xs opacity-70">Task is waiting to be started</p>
              </div>
            </button>

            <button
              onClick={() => handleStatusUpdate('IN_PROGRESS')}
              disabled={selectedTaskForStatus?.originalStatus === 'IN_PROGRESS'}
              className={`w-full text-left px-4 py-3 rounded-lg border transition-colors duration-200 flex items-center gap-3 ${
                selectedTaskForStatus?.originalStatus === 'IN_PROGRESS'
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed border-gray-200 dark:border-gray-600'
                  : 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/40'
              }`}
            >
              <div className="w-3 h-3 bg-blue-400 rounded-full"></div>
              <div>
                <p className="font-medium">In Progress</p>
                <p className="text-xs opacity-70">Task is currently being worked on</p>
              </div>
            </button>

            <button
              onClick={() => handleStatusUpdate('COMPLETED')}
              disabled={selectedTaskForStatus?.originalStatus === 'COMPLETED'}
              className={`w-full text-left px-4 py-3 rounded-lg border transition-colors duration-200 flex items-center gap-3 ${
                selectedTaskForStatus?.originalStatus === 'COMPLETED'
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed border-gray-200 dark:border-gray-600'
                  : 'bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 border-green-200 dark:border-green-700 hover:bg-green-100 dark:hover:bg-green-900/40'
              }`}
            >
              <div className="w-3 h-3 bg-green-400 rounded-full"></div>
              <div>
                <p className="font-medium">Completed</p>
                <p className="text-xs opacity-70">Task has been finished</p>
              </div>
            </button>

            <button
              onClick={() => handleStatusUpdate('CANCELLED')}
              disabled={selectedTaskForStatus?.originalStatus === 'CANCELLED'}
              className={`w-full text-left px-4 py-3 rounded-lg border transition-colors duration-200 flex items-center gap-3 ${
                selectedTaskForStatus?.originalStatus === 'CANCELLED'
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed border-gray-200 dark:border-gray-600'
                  : 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border-red-200 dark:border-red-700 hover:bg-red-100 dark:hover:bg-red-900/40'
              }`}
            >
              <div className="w-3 h-3 bg-red-400 rounded-full"></div>
              <div>
                <p className="font-medium">Cancelled</p>
                <p className="text-xs opacity-70">Task has been cancelled</p>
              </div>
            </button>
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button
              onClick={() => setIsStatusModalOpen(false)}
              className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500"
            >
              Cancel
            </button>
          </div>
        </div>
      </Models>

      {/* Delete Confirmation Modal */}
      <Models isOpen={isDeleteModalOpen} isClose={() => setIsDeleteModalOpen(false)}>
        <div className="p-6 max-w-md w-full bg-white dark:bg-gray-800">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-900/20 mb-4">
              <svg className="h-6 w-6 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            <h2 className="text-lg font-bold mb-2 text-gray-900 dark:text-gray-100">Delete Task</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Are you sure you want to delete this task?
            </p>
            
            {selectedTaskForDelete && (
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg mb-4 mt-3">
                <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {selectedTaskForDelete.originalTitle}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Assigned to: {selectedTaskForDelete.assignedTo}
                </p>
              </div>
            )}
            
            <p className="text-xs text-red-600 dark:text-red-400 mb-6">
              This action cannot be undone.
            </p>
          </div>

          <div className="flex gap-3 justify-center">
            <button
              onClick={() => setIsDeleteModalOpen(false)}
              className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              onClick={handleDeleteConfirm}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  Deleting...
                </div>
              ) : (
                'Delete Task'
              )}
            </button>
          </div>
        </div>
      </Models>
    </>
  );
}
